const screenSizes = {
  smallMobile: 393,
  mobile: 600,
  tablet: 905,
  desktop: 1024,
  mediumDesktop: 1240,
  largeDesktop: 1440,
  hugeDesktop: 1666,
};

export const { smallMobile, mobile, tablet, desktop, mediumDesktop, largeDesktop, hugeDesktop } = screenSizes;
